import axios from 'axios'

class ProductsQueries {
    fetchProductType(productId) {
        return axios.get(`/products/product-types/${productId}`)
    }

    updateProduct(productId, payload) {
        return axios.put(`/products/product-types/${productId}`, payload)
    }

    fetchProductTypes(params) {
        return axios.get('/products/product-types', { params })
    }

    // Additional methods for product edit view
    fetchProductProductionProperties(params) {
        return axios.get('/products/product-production-properties', { params })
    }

    fetchProductComponents(params) {
        return axios.get('/products/product-components', { params })
    }

    fetchProductionProcesses(params) {
        return axios.get('/production-processes/processes', { params })
    }

    fetchProductPropertiesByProductType(productTypeId, params) {
        return axios.get('/products/product-properties', {
            params: { ...params, productTypeId }
        })
    }

    fetchProductProperties(params) {
        return axios.get('/products/product-properties', { params })
    }
}

export default new ProductsQueries()
